export const VALIDATION_REG_EXP_FIRST_NAME = /^.{2,20}$/
export const VALIDATION_REG_EXP_LAST_NAME = /^.{2,20}$/
export const VALIDATION_REG_EXP_MIDDLE_NAME = /^.{2,20}$/
export const VALIDATION_REG_EXP_PREFERRED_NAME = /^.{2,16}$/
export const VALIDATION_REG_EXP_MOBILE = /^(\+[0-9()]{2,15}|[0-9()]{2,16})$/
export const VALIDATION_REG_EXP_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const VALIDATION_REG_EXP_SECRET_CODE = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&?]{8,16}$/
export const VALIDATION_REG_EXP_PIN_CODE = /^[0-9]{8}$/
export const VALIDATION_REG_EXP_PIN_CODE_NCENTRAL = /^[0-9]{3,6}$/
